export default "__VITE_ASSET__kUmdgT5G__"